/* ============================================================================
   cl-pdp-eenregel.js — houdt een zin op één regel (Cecile Lavelle)

   Elk element met `data-cl-eenregel` moet op één regel passen zonder ingekort
   te worden. De CSS doet het meeste werk: die laat de graad met de
   schermbreedte meebewegen, berekend op de Duitse zin. Dit script is het
   vangnet voor alles wat die berekening niet kan weten — een langere vertaling,
   een langere campagnenaam, een breder lettertype dat later wordt geladen.

   Werkwijze: meten of de tekst breder is dan zijn ruimte, en zo ja de graad in
   kleine stappen omlaag tot hij past. Nooit afkappen, nooit laten afbreken, en
   nooit onder de ondergrens die op het element staat — een zin die niemand kan
   lezen is geen oplossing. Wordt die grens gehaald en past hij nog niet, dan
   mag hij alsnog afbreken; twee leesbare regels is beter dan één onleesbare.

   Waarom niet alleen javascript: zonder dit bestand klopt de band nog steeds,
   want de CSS-berekening dekt het Duits van 320 tot 430 px. Dit maakt het
   alleen taalvast.
   ============================================================================ */
(function () {
  'use strict';

  var STAP = 0.25;      // px per stap — kleiner dan het oog ziet
  var MAX_STAPPEN = 40; // 10 px speling; daarna houdt het op

  // De meting gaat over het kader, niet over de tekst zelf. Een element met
  // `white-space:nowrap` in een flexrij groeit gewoon mee met zijn inhoud, dus
  // zijn scrollWidth is altijd gelijk aan zijn clientWidth — het loopt nooit
  // over zichzélf, het duwt de rij eromheen uit. Op de tekst meten leverde
  // daarom altijd "past" op, ook bij een zin die er twee keer zo lang was.
  function looptUit(el) {
    var kader = el.parentElement;
    return kader ? kader.scrollWidth > kader.clientWidth + 0.5 : false;
  }

  function pas(el) {
    var ondergrens = parseFloat(el.getAttribute('data-cl-eenregel')) || 8;

    // Eerst terug naar de maat uit de CSS, anders stapelen krimpstappen zich op
    // bij het draaien van het scherm.
    el.style.fontSize = '';
    el.style.whiteSpace = 'nowrap';

    var maat = parseFloat(getComputedStyle(el).fontSize);
    var stappen = 0;

    while (looptUit(el) && maat > ondergrens && stappen < MAX_STAPPEN) {
      maat -= STAP;
      el.style.fontSize = maat + 'px';
      stappen++;
    }

    // Past het bij de ondergrens nog steeds niet, dan mag hij afbreken.
    el.style.whiteSpace = looptUit(el) ? '' : 'nowrap';
  }

  function alles() {
    var lijst = document.querySelectorAll('[data-cl-eenregel]');
    for (var i = 0; i < lijst.length; i++) pas(lijst[i]);
  }

  function start() {
    alles();
    // Lettertypen komen later binnen en veranderen de breedte van de zin.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(alles);
    window.addEventListener('resize', alles, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
